import {
  GET_MATERIAL_REQUESTS,
  GET_MATERIAL_REQUEST,
  CREATE_MATERIAL_REQUEST,
  UPDATE_MATERIAL_REQUEST,
  DELETE_MATERIAL_REQUEST
} from '../actions/materialRequestActions';

const initialState = {
  materialRequests: [],
  materialRequest: null,
  numberOfPages: 0,
  currentPage: 1,
  isLoading: false
};

const materialRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MATERIAL_REQUESTS:
      return {
        ...state,
        materialRequests: action.payload.requests,
        numberOfPages: action.payload.totalPages,
        currentPage: action.payload.currentPage,
        isLoading: false
      };

    case GET_MATERIAL_REQUEST:
      return {
        ...state,
        materialRequest: action.payload,
        isLoading: false
      };

    case CREATE_MATERIAL_REQUEST:
      return {
        ...state,
        materialRequests: [action.payload, ...state.materialRequests]
      };

    case UPDATE_MATERIAL_REQUEST:
      return {
        ...state,
        materialRequests: state.materialRequests.map(r =>
          r._id === action.payload._id ? action.payload : r
        ),
        materialRequest: action.payload
      };

    case DELETE_MATERIAL_REQUEST:
      return {
        ...state,
        materialRequests: state.materialRequests.filter(r => r._id !== action.payload)
      };

    default:
      return state;
  }
};

export default materialRequestReducer;
